import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { TrainingForm } from "@/components/forms/TrainingForm";

export function TrainingDialog({ coach = "", children }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="bg-ink-800 border-white/10 text-white max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="training-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-3xl tracking-wide text-white">
            Training Inquiry{coach ? ` — ${coach}` : ""}
          </DialogTitle>
          <DialogDescription className="text-white/60">
            Tell us about the player and what you're looking for. A coach will follow up.
          </DialogDescription>
        </DialogHeader>
        <TrainingForm defaultCoach={coach} onDone={() => setOpen(false)} className="mt-2" />
      </DialogContent>
    </Dialog>
  );
}
